<template>
    <section>
        <div id="headerPlano" :class="{ 'flexContainer jc-fe': getMode === 'module' }">
            <!-- <selector-lang classescss="langselector&#45;&#45;in-plano txtCenter uppercase support pointer"></selector-lang> -->
            <button
                v-if="getMode === 'module' && !isMobile"
                class="btnBase uppercase shades pointer"
                :class="{ active: canDisplayMenuShades }"
                @click="shades"
            >
                <span>{{ $t("planobuilder.shades") }}</span>
            </button>
            <button
                v-if="getMode === 'module' && lock === 'false' && !isMobile"
                class="btnBase uppercase ticketstrip pointer"
                :class="{ active: canDisplayMenuTicketStrip }"
                @click="ticketStrip"
            >
                <span>{{ $t("planobuilder.ticketStrip") }}</span>
            </button>
            <button
                v-if="getMode !== 'module' && lock === 'false' && !isMobile && !getPlanoDetails.archived && getPlanoDetails.status === 'IN PROGRESS'"
                class="btnBase uppercase favorites fright pointer"
                :class="{ active: canDisplayMenuFavorite }"
                @click="favorites"
            >
                <span>{{ $t("planobuilder.favorite") }}</span>
            </button>
            <button
                v-if="getMode !== 'module' && lock === 'false' && !isMobile && !getPlanoDetails.archived && getPlanoDetails.status === 'IN PROGRESS'"
                class="btnBase uppercase scratch fright pointer"
                :class="{ active: canDisplayMenuScratch }"
                @click="scratchPad"
            >
                <span>{{ $t("planobuilder.scratch") }}</span>
            </button>
            <button
                v-if="getMode !== 'module' && lock === 'false' && !isMobile && !getPlanoDetails.archived && getPlanoDetails.status === 'IN PROGRESS'"
                class="btnBase uppercase library fright pointer"
                :class="{ active: canDisplayMenuLibrary }"
                @click="library"
            >
                <span>{{ $t("planobuilder.library") }}</span>
            </button>
        </div>
    </section>
</template>

<script>
import { bus } from "../../../main";
import Vuex from "vuex";
import Globals from "../../globals";
import { stateMixin } from "./../mixins/state";
import SelectorLang from "../../../components/langSelector/langSelector.vue";
import cacheService from "@/services/cache";

export default {
    components: {
        selectorLang: SelectorLang
    },
    mixins: [stateMixin],
    data: () => ({
        menuHeader: false,
        menuShades: false,
        scratch: false,
        menu: false,
        favorite: false,
        comment: false,
        support: false,
        lock: "",
        commentsNB: "",
        globals: Globals.getBaseUrl(),
        isMobile: Globals.isMobile(),
        user: ""
    }),
    watch: {
        retCom: function(val) {
            this.commentsNB = val;
        }
    },
    methods: {
        isNotSafari() {
            return Globals.getNavigator() !== Globals.NAVIGATOR_SAFARI;
        },
        exportPdf() {
            // bus.$emit('plano_exportPdf')
            let display = !this.canDisplayExports;
            this.setDisplayExports(display);
        },
        comments() {
            let display = !this.canDisplayComments;
            this.setDisplayComments(display);
        },
        favorites() {
            let display = !this.canDisplayMenuFavorite;
            this.setDisplayMenuFavorite(display);
        },
        scratchPad() {
            let display = !this.canDisplayMenuScratch;
            this.setDisplayMenuScratch(display);
        },
        library() {
            let display = !this.canDisplayMenuLibrary;
            this.setDisplayMenuLibrary(display);
            this.$router.push({ name: "Plano", query: this.getLinkParams({ type: 1 }) });
        },
        shades() {
            let display = !this.canDisplayMenuShades;
            this.setDisplayMenuShades(display);
        },
        ticketStrip() {
            let display = !this.canDisplayMenuTicketStrip;
            this.setDisplayMenuTicketStrip(display);
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                if (x[key] !== null) {
                    temp[key] = this.$route.query[key];
                }
            }

            for (let key in x) {
                if (x[key] !== null) {
                    temp[key] = x[key];
                }
            }
            return temp;
        }
    },
    computed: {
        retCom() {
            return this.$store.state.plano.data.commentNb;
        },
        ...Vuex.mapGetters({
            getComments: "plano/data/getComments",
            getCommentsNb: "plano/data/getCommentsNb",
            getPlanoDetails: "plano/data/getPlanoDetails"
        })
    },
    created() {
        this.$store.dispatch("plano/data/getComments", { id: this.$route.params.id }).then(() => {
            this.commentsNB = this.getComments.length;
        });
        bus.$on("openLibrary", event => {
            this.menuShades = false;
            this.comment = false;
            this.scratch = false;
            this.favorite = false;
        });
        bus.$on("openShades", event => {
            this.menuHeader = false;
            this.comment = false;
            this.scratch = false;
            this.favorite = false;
        });
        bus.$on("openComments", event => {
            this.menuShades = false;
            this.menuHeader = false;
            this.scratch = false;
            this.favorite = false;
        });
        bus.$on("openScratch", event => {
            this.menuShades = false;
            this.menuHeader = false;
            this.favorite = false;
            this.comment = false;
        });
        bus.$on("openFavorite", event => {
            this.menuShades = false;
            this.menuHeader = false;
            this.scratch = false;
            this.comment = false;
        });
        bus.$on("moduleClosed", event => {
            this.menuShades = false;
            this.menuHeader = false;
        });
        this.lock = cacheService.get("planoLocked");
        this.user = cacheService.getRem3rchUser().user;
    },
    beforeDestroy() {
        bus.$off("openLibrary");
        bus.$off("openShades");
        bus.$off("openComments");
        bus.$off("openScratch");
        bus.$off("openFavorite");
        bus.$off("moduleClosed");
    }
};
</script>
<style lang="scss" scoped>
.lock {
    /*width: 10%;*/
}

#library {
    background-color: white;
    width: 25%;
    right: 0;
    height: 10vh;
}

.ticketstrip {
    margin-left: 10px;
}

#headerPlano {
    background-color: white;
    padding: 0 20px;
    position: relative;
    z-index: 25;
    button {
        padding: 20px 0;
        &.active {
            border-bottom: 1px solid #343434;
        }
    }
    .btnBase {
        border: none;
        background-color: white;
        font-family: Roboto;
        font-size: 14px;
        color: #343434;
        &.active {
            font-weight: 500;
            border-bottom: 2px solid #343434;
        }
    }
    .btnLeft {
        border: none;
        background-color: white;
        font-family: Roboto;
        font-size: 14px;
        color: #343434;
        &.active {
            font-weight: 500;
            border-bottom: 2px solid #343434;
        }
    }
    .export,
    .support,
    .comment,
    .scratch,
    .library,
    .favorites {
        .supportLink {
            text-decoration: none;
            color: #343434;
            &:visited {
                color: #343434;
            }
        }

        span {
            border-right: 1px solid #a8a8a8;
            padding: 0 29px;
        }
        .shades {
            padding: 30px;
        }
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    #headerPlano {
        display: flex;
        .btnBase,
        .btnLeft {
            font-size: 1.15rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// MenuMainPlanoMassMarket.vue?972fd4c8